import { render, staticRenderFns } from "./ImageRender.vue?vue&type=template&id=0d3e8546&scoped=true&"
import script from "./ImageRender.vue?vue&type=script&lang=js&"
export * from "./ImageRender.vue?vue&type=script&lang=js&"
import style0 from "./ImageRender.vue?vue&type=style&index=0&id=0d3e8546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3e8546",
  null
  
)

export default component.exports